export default __webpack_public_path__ + "static/media/santosh.b99c7efb.jpeg";